import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ModalService } from './../modal.service';

@Component({
    selector: 'mlp-ng-modal-secondary',
    templateUrl: './modal-secondary.component.html',
    styleUrls: ['./modal-secondary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ModalSecondarySharedComponent {
    constructor(
        public modService: ModalService
    ) {}
}
